<div class="trace-container min-h-screen rounded-lg bg-white p-4 dark:bg-black">
  <p-breadcrumb [model]="breadcrumbs" styleClass="rounded-lg border border-gray-200 dark:border-gray-800">
    <ng-template #separator>
      <i class="pi pi-chevron-right text-primary-400 text-sm mx-2"></i>
    </ng-template>
    <ng-template #item let-item>
      @if (item.routerLink) {
        <a
          [routerLink]="item.routerLink"
          class="flex items-center text-primary-600 hover:text-primary-800 dark:hover:text-primary-500 dark:text-primary-300 transition-colors duration-200"
        >
          @if (item.icon) {
            <i [class]="item.icon + ' mr-2'"></i>
          }
          <span>{{ item.label }}</span>
        </a>
      } @else {
        <span class="flex items-center text-primary-600 dark:text-primary-300">
          <span class="font-medium">{{ item.label }}</span>
        </span>
      }
    </ng-template>
  </p-breadcrumb>

  <div class="mt-4 space-y-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Historial de registro</h1>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
        Busca cualquier identificador para ver su recorrido completo entre workflows
      </p>
    </div>

    <div
      class="rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
    >
      <div
        class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700"
      >
        <div class="flex items-center gap-2">
          <i class="pi pi-search text-sm text-gray-500 dark:text-gray-400"></i>
          <span class="text-sm font-medium text-gray-800 dark:text-gray-100">Filtros</span>
          <span
            class="inline-flex items-center rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-semibold text-primary-700 dark:bg-primary-900/30 dark:text-primary-300"
          >
            {{ activeFiltersCount() }} activos
          </span>
        </div>
        @if (activeFiltersCount() > 0) {
          <button
            (click)="clearFilters()"
            class="flex h-7 items-center gap-1.5 rounded-md px-2 text-xs text-gray-600 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
            type="button"
          >
            <i class="pi pi-filter-slash text-[11px]"></i>
            <span>Limpiar</span>
          </button>
        }
      </div>

      <div class="p-4">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-[14rem_minmax(0,1fr)_auto] md:items-end">
          <div class="flex flex-col gap-1.5">
            <label class="text-xs font-medium text-gray-500 dark:text-gray-400" for="trace-field">
              Campo
            </label>
            <p-select
              [(ngModel)]="selectedField"
              [options]="fieldSelectOptions()"
              appendTo="body"
              class="w-full"
              inputId="trace-field"
              optionLabel="label"
              optionValue="value"
            />
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-xs font-medium text-gray-500 dark:text-gray-400" for="trace-identifier">
              Identificador
            </label>
            <div class="relative">
              <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                (keyup.enter)="search()"
                [(ngModel)]="identifier"
                class="w-full pl-10!"
                id="trace-identifier"
                pInputText
                placeholder="Ej. 638508"
                type="text"
              />
            </div>
          </div>

          <p-button
            (onClick)="search()"
            [loading]="loading()"
            icon="pi pi-search"
            label="Buscar"
            severity="primary"
            styleClass="w-full gap-2"
            type="button"
          />
        </div>

        <button
          (click)="toggleFilters()"
          class="mt-4 flex items-center gap-2 text-xs font-medium text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
          type="button"
        >
          <i class="pi pi-sliders-h text-[11px]"></i>
          Filtros avanzados
          <i [ngClass]="showFilters() ? 'pi-chevron-up' : 'pi-chevron-down'" class="pi text-[11px]"></i>
        </button>

        @if (showFilters()) {
          <div
            class="mt-3 grid grid-cols-1 gap-4 border-t border-gray-200 pt-4 dark:border-gray-700 md:grid-cols-[minmax(0,1fr)_10rem_10rem_auto] md:items-start"
          >
            <div class="flex flex-col gap-1.5">
              <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Estado</span>
              <div class="flex flex-wrap gap-2">
                @for (option of statusOptions; track option.value) {
                  <button
                    (click)="toggleStatus(option.value); search()"
                    [class.border-primary-600]="isStatusSelected(option.value)"
                    [class.bg-primary-600]="isStatusSelected(option.value)"
                    [class.text-white]="isStatusSelected(option.value)"
                    [class.bg-white]="!isStatusSelected(option.value)"
                    [class.text-gray-600]="!isStatusSelected(option.value)"
                    class="h-8 rounded-full border border-gray-300 px-3 text-xs font-medium dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300"
                    type="button"
                  >
                    {{ option.label }}
                  </button>
                }
              </div>
            </div>

            <div class="flex flex-col gap-1.5">
              <label for="date-from-input" class="text-xs font-medium text-gray-500 dark:text-gray-400">Desde</label>
              <input id="date-from-input" type="date" [(ngModel)]="dateFrom" class="w-full" pInputText />
            </div>

            <div class="flex flex-col gap-1.5">
              <label for="date-to-input" class="text-xs font-medium text-gray-500 dark:text-gray-400">Hasta</label>
              <input id="date-to-input" type="date" [(ngModel)]="dateTo" class="w-full" pInputText />
            </div>

            <div class="flex flex-col gap-1.5 md:border-l md:border-gray-200 md:pl-4 md:dark:border-gray-700">
              <div class="flex items-center gap-2">
                <p-toggleswitch [(ngModel)]="deepMode" inputId="deep-mode-switch" />
                <label for="deep-mode-switch" class="text-xs font-medium text-gray-700 dark:text-gray-300">
                  Búsqueda profunda
                </label>
              </div>
              <p class="max-w-[200px] text-[11px] text-gray-400 dark:text-gray-500">
                Para identificadores no indexados. Requiere Desde y Hasta (máx. 3 días).
              </p>
            </div>
          </div>
        }

        @if (hasActiveFilters()) {
          <div class="mt-3 flex flex-wrap gap-2">
            @for (statusValue of selectedStatuses(); track statusValue) {
              <span
                class="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700 dark:bg-primary-900/30 dark:text-primary-300"
              >
                Estado: {{ getStatusLabel(statusValue) }}
                <i (click)="removeStatusChip(statusValue)" (keyup.enter)="removeStatusChip(statusValue)" tabindex="0" role="button" class="pi pi-times cursor-pointer text-xs"></i>
              </span>
            }
            @if (dateFrom()) {
              <span
                class="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700 dark:bg-primary-900/30 dark:text-primary-300"
              >
                Desde {{ dateFrom() }}
                <i (click)="clearDateFrom()" (keyup.enter)="clearDateFrom()" tabindex="0" role="button" class="pi pi-times cursor-pointer text-xs"></i>
              </span>
            }
            @if (dateTo()) {
              <span
                class="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700 dark:bg-primary-900/30 dark:text-primary-300"
              >
                Hasta {{ dateTo() }}
                <i (click)="clearDateTo()" (keyup.enter)="clearDateTo()" tabindex="0" role="button" class="pi pi-times cursor-pointer text-xs"></i>
              </span>
            }
          </div>
        }
      </div>
    </div>

    @if (error()) {
      <div
        class="rounded-xl border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-700 dark:border-red-800 dark:bg-red-900/30 dark:text-red-300"
      >
        {{ error() }}
      </div>
    }

    @if (result() && !loading()) {
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-4">
        <p-card class="h-full">
          <div class="flex items-center gap-3">
            <div
              class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 dark:bg-primary-900/30"
            >
              <i class="pi pi-hashtag text-lg text-primary-600 dark:text-primary-400"></i>
            </div>
            <div>
              <p class="text-sm text-gray-500 dark:text-gray-400">Registro</p>
              <p class="text-lg font-bold text-gray-900 dark:text-white">
                {{ result()!.identifier }}
              </p>
            </div>
          </div>
        </p-card>

        <p-card class="h-full">
          <div class="flex items-center gap-3">
            <div
              class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-100 dark:bg-blue-900/30"
            >
              <i class="pi pi-sync text-lg text-blue-600 dark:text-blue-400"></i>
            </div>
            <div>
              <p class="text-sm text-gray-500 dark:text-gray-400">Ejecuciones</p>
              <p class="text-2xl font-bold text-blue-600 dark:text-blue-400">
                {{ result()!.summary.total_executions }}
              </p>
            </div>
          </div>
        </p-card>

        <p-card class="h-full">
          <div class="flex items-center gap-3">
            <div
              class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-700"
            >
              <i class="pi pi-sitemap text-lg text-gray-500 dark:text-gray-300"></i>
            </div>
            <div>
              <p class="text-sm text-gray-500 dark:text-gray-400">Workflows</p>
              <p class="text-2xl font-bold text-gray-900 dark:text-white">
                {{ result()!.summary.distinct_workflows }}
              </p>
            </div>
          </div>
        </p-card>

        <p-card class="h-full">
          <div class="flex items-center gap-3">
            <div
              [ngClass]="
                result()!.summary.last_status === 'success'
                  ? 'bg-emerald-100 dark:bg-emerald-900/30'
                  : 'bg-red-100 dark:bg-red-900/30'
              "
              class="flex size-10 shrink-0 items-center justify-center rounded-lg"
            >
              <i
                [ngClass]="
                  result()!.summary.last_status === 'success'
                    ? 'pi pi-check-circle text-emerald-600 dark:text-emerald-400'
                    : 'pi pi-times-circle text-red-600 dark:text-red-400'
                "
                class="text-lg"
              ></i>
            </div>
            <div>
              <p class="text-sm text-gray-500 dark:text-gray-400">Último estado</p>
              <p class="text-lg font-bold text-gray-900 dark:text-white capitalize">
                {{ result()!.summary.last_status }}
              </p>
            </div>
          </div>
        </p-card>
      </div>

      @if (result()!.runs.length === 0) {
        <div
          class="overflow-hidden rounded-xl border border-gray-200 bg-white p-10 text-center shadow-sm dark:border-gray-700 dark:bg-gray-900"
        >
          <i class="pi pi-inbox text-3xl text-gray-300 dark:text-gray-600"></i>
          <p class="mt-3 text-sm font-medium text-gray-900 dark:text-white">
            No se encontraron ejecuciones con el criterio ingresado
          </p>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Verifica que el Work origen tenga configurados los origin_keys correspondientes
          </p>
        </div>
      }

      @for (run of result()!.runs; track run.execution_list_id) {
        <div
          class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
        >
          <div
            class="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/70"
            (click)="toggleRun(getRunKey(run))"
            (keyup.enter)="toggleRun(getRunKey(run))"
            tabindex="0"
            role="button"
          >
            <div class="flex items-center gap-3">
              <span
                [ngClass]="getStatusDotClass(run.status)"
                class="h-2.5 w-2.5 rounded-full"
              ></span>
              <div>
                <p class="font-medium text-gray-900 dark:text-white">{{ run.workflow_name }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  {{ run.started_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                </p>
              </div>
            </div>
                        <i
              [ngClass]="isExpanded(getRunKey(run)) ? 'pi-chevron-up' : 'pi-chevron-down'"
              class="pi text-sm text-gray-400"
            ></i>
          </div>

          @if (isExpanded(getRunKey(run))) {
            <div class="border-t border-gray-200 bg-gray-50/60 px-5 py-4 dark:border-gray-700 dark:bg-gray-800/30">
              @for (step of run.steps; track step.execution_id) {
                <div class="flex items-start gap-3 py-2">
                  <span
                    [ngClass]="getStatusDotClass(step.status)"
                    class="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full"
                  ></span>
                  <div class="flex-1">
                    <div class="flex items-center justify-between gap-2">
                      <p class="text-sm font-medium text-gray-900 dark:text-white">
                        {{ step.work_name }}
                        <span class="text-xs font-normal text-gray-400">({{ step.work_type }})</span>
                      </p>
                                            <div class="flex shrink-0 items-center gap-1">
                        @if (run.execution_list_id !== null) {
                          <button
                            (click)="openHistoryPage(run.workflow_id, run.execution_list_id, step.execution_id)"
                            pTooltip="Ver detalle completo"
                            class="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-primary-600 dark:hover:bg-gray-800"
                          >
                            <i class="pi pi-external-link text-xs"></i>
                          </button>
                        } @else {
                          <span
                            pTooltip="Sin corrida asociada, no se puede abrir el historial"
                            class="text-[10px] font-medium text-amber-600 dark:text-amber-400"
                          >
                            Sin corrida
                          </span>
                        }
                      </div>
                    </div>
                    <p class="text-[11px] text-gray-400">
                      ID ejecución: #{{ step.execution_id }} · Work #{{ step.work_id }}
                    </p>
                    @if (step.status === 'error') {
                      <div
                        class="mt-1 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700 dark:border-red-800 dark:bg-red-900/30 dark:text-red-300"
                      >
                        {{ step.message }}
                      </div>
                    } @else {
                      <p class="text-xs text-gray-500 dark:text-gray-400">{{ step.message }}</p>
                    }
                  </div>
                </div>
              }

              @if (run.status === 'error') {
                <div class="mt-3 flex items-center gap-3 border-t border-gray-200 pt-3 dark:border-gray-700">
                  <p-button
                    (onClick)="retryRun(run.workflow_id, run.execution_list_id)"
                    [loading]="isRetrying(run.execution_list_id)"
                    icon="pi pi-refresh"
                    label="Reintentar"
                    severity="secondary"
                    size="small"
                    type="button"
                  />
                  @if (retrySuccessMessage()) {
                    <span class="text-xs text-emerald-600 dark:text-emerald-400">
                      {{ retrySuccessMessage() }}
                    </span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
    @if (result() && result()!.executions_count > pageSize) {
        <div class="rounded-xl border border-gray-200 bg-white px-2 py-1 dark:border-gray-700 dark:bg-gray-900">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="(currentPage() - 1) * pageSize"
            [rows]="pageSize"
            [totalRecords]="result()!.executions_count"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} ejecuciones"
          ></p-paginator>
        </div>
      }

    @if (deepResult() && !loading()) {
      <div
        class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
      >
        <div class="border-b border-gray-200 px-5 py-4 dark:border-gray-700">
          <div class="flex items-center gap-2">
            <i class="pi pi-search-plus text-primary-600 dark:text-primary-400"></i>
            <h2 class="font-semibold text-gray-900 dark:text-white">Resultado de búsqueda profunda</h2>
          </div>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Rango consultado: {{ deepResult()!.date_from }} — {{ deepResult()!.date_to }}
          </p>
        </div>

        @if (deepResult()!.error) {
          <div class="px-5 py-4 text-sm text-red-600 dark:text-red-400">
            {{ deepResult()!.error }}
          </div>
        } @else {
          <div class="grid grid-cols-1 gap-4 p-5 sm:grid-cols-3">
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Coincidencias encontradas</p>
              <p class="text-2xl font-bold text-gray-900 dark:text-white">
                {{ deepResult()!.matched_ids_count }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Ventanas revisadas</p>
              <p class="text-2xl font-bold text-gray-900 dark:text-white">
                {{ deepResult()!.windows_checked }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Resultado completo</p>
              <p
                class="text-lg font-bold"
                [class.text-emerald-600]="!deepResult()!.partial"
                [class.text-amber-600]="deepResult()!.partial"
              >
                {{ deepResult()!.partial ? 'Parcial (se cortó por tiempo)' : 'Completo' }}
              </p>
            </div>
          </div>

          @if (deepResult()!.matches.length > 0) {
            <div class="border-t border-gray-200 px-5 py-4 dark:border-gray-700">
              <p class="mb-2 text-xs font-medium text-gray-500 dark:text-gray-400">
                Ejecuciones encontradas (primeras {{ deepResult()!.matches.length }})
              </p>
              <div class="space-y-2">
                @for (match of deepResult()!.matches; track match.execution_id) {
                  <div class="flex items-center justify-between gap-2 rounded-lg border border-gray-200 px-3 py-2 dark:border-gray-700">
                    <div class="flex items-center gap-2">
                      <span
                        [ngClass]="getStatusDotClass(match.status)"
                        class="h-2 w-2 shrink-0 rounded-full"
                      ></span>
                      <div>
                        <p class="text-xs font-medium text-gray-900 dark:text-white">
                          Ejecución #{{ match.execution_id }} · Work #{{ match.work_id }}
                        </p>
                        <p class="text-[11px] text-gray-500 dark:text-gray-400">
                          {{ match.started_at | date: 'dd/MM/yyyy HH:mm:ss' }} — {{ match.message }}
                        </p>
                      </div>
                    </div>
                    @if (match.workflow_id !== null && match.execution_list_id !== null) {
                      <button
                        (click)="openHistoryPage(match.workflow_id, match.execution_list_id, match.execution_id)"
                        pTooltip="Ver detalle completo"
                        class="shrink-0 rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-primary-600 dark:hover:bg-gray-800"
                      >
                        <i class="pi pi-external-link text-xs"></i>
                      </button>
                    } @else {
                      <span
                        pTooltip="Sin corrida asociada, no se puede abrir el historial"
                        class="shrink-0 text-[10px] font-medium text-amber-600 dark:text-amber-400"
                      >
                        Sin corrida
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="border-t border-gray-200 px-5 py-4 text-center text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400">
              No se encontraron coincidencias en el rango consultado.
            </div>
          }
        }
      </div>
    }
  </div>
</div>